import { atom } from 'jotai';
import { Step } from './DeliveryFrequencyV2.types';
import { INITIAL_STEP, CHANGE_FREQUENCY_STEP } from './constants';

export const stepDateFrequencyModalAtom = atom<Step>(CHANGE_FREQUENCY_STEP[INITIAL_STEP]);
